import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = {
  key: 0,
  class: "bordered-card w-100"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Documents Currently On File/Pending Admin Preview", -1)
const _hoisted_4 = { class: "small mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "text-center mb-4 mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.documents.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("table", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "javascript;",
                          onClick: _withModifiers(($event: any) => (_ctx.openModal('smartsearch', null, 'modal-success', null, { DocumentID: document.DocumentID })), ["prevent"])
                        }, _toDisplayString(document.Type.Description), 9, _hoisted_6)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(document.Date), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'text-danger': document.Status === 'Pending' })
                      }, _toDisplayString(document.Status), 3)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, " No documents have been uploaded to your account."))
      ]))
}